import * as React from 'react';
import { urlStateToWebUrl, webUrlToUrlState } from '@westwing/looks-url-service';
import { useSEOLinks } from '../hooks/useSEOLinks';
import SeoHead from 'Client/components/Generic/SeoHead';
import useConfig from 'Client/hooks/useConfig';
import { SEO_CONSTANTS } from 'Client/components/ListingPage/services/seo/constant';
import useRouter from 'Client/hooks/useRouter';
import { useBellaSelector } from 'Client/redux/hooks';

export const LooksSeoHead = () => {
    const config = useConfig();
    const {
        host,
        location: { pathname, search },
    } = useRouter();
    const {
        listing,
        seoData: { metaTitle, metaDescription, hreflangs = {}, indexFollow },
    } = useBellaSelector(state => state.looksPage.looks);

    const { pageType, rooms, styles } = webUrlToUrlState(pathname);

    const pageUrl = `${urlStateToWebUrl({ pageType, rooms, styles }, host)}${search}`;

    const links = useSEOLinks(pageUrl, hreflangs);

    /**
     * This is a temporary solution to avoid indexing of pages with style filters.
     * once the API fixes the meta descriotion for styles and styles+rooms filter
     * we must index all LLP pages. Same goes for page title.
     */
    const robotsIndexableContent = indexFollow ? SEO_CONSTANTS.indexable : SEO_CONSTANTS.noIndexable;

    const openGraphImage = `https:${listing[0]?.portraitImage}`;

    return (
        <SeoHead
            config={config}
            pageTitle={metaTitle}
            pageDescription={metaDescription}
            pageUrl={pageUrl}
            robotsIndexAbleContent={robotsIndexableContent}
            links={links}
            type={SEO_CONSTANTS.ogTypeContentValue}
            openGraphImage={openGraphImage}
        />
    );
};
